import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import {
  adjustDateFormatAsPerPCalendar,
  adjustMonthFormatAsPerPCalendar,
  BreadCrumbModel, CrudService, CustomDirectiveConfig, datePipeConversion, formConfigs, IApplicationResponse, LEAD_PASSPORT_MONTH_TRANSFORM, LoggedInUserModel, ModulesBasedApiSuffix, prepareGetRequestHttpParams, RxjsService, SERVER_REQUEST_DATE_TRANSFORM, standardHeightForPscrollContainer, fileUrlDownload, ResponseMessageTypes, SnackbarService
} from '@app/shared';
import { loggedInUserData } from '@modules/others';
import {
  CreditVettingInfo, DebtorType, LeadHeaderData,
  SalesModuleApiSuffixModels, selectLeadCreationStepperParamsState$,
  selectLeadHeaderDataState$, ServiceAgreementStepsParams
} from '@modules/sales';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';

export enum SystemOwnershipEnumId {
  OWNED = 1,
  RENTED = 2
}

@Component({
  selector: 'credit-vetting-result',
  templateUrl: './credit-vetting-result.component.html',
  styleUrls: ['./service-installation-agreement.scss']
})

export class CreditVettingResultComponent implements OnInit {
  serviceAgreementStepsParams: ServiceAgreementStepsParams;
  leadHeaderData: LeadHeaderData;
  details: any = { debtorInformation: { dob: "" } };
  creditVettingInfoForm: FormGroup;
  IsInstallationDebtor: boolean = false;
  loggedInUserData: LoggedInUserModel;
  needleValue: Number = 0;
  bottomLabel;
  options = {
    hasNeedle: true,
    needleColor: 'gray',
    needleUpdateSpeed: 1000,
    arcColors: ["rgb(255,84,84)", "rgb(239,214,19)", "rgb(61,204,91)"],
    arcDelimiters: [35, 70],
    rangeLabel: ['0', '900'],
    needleStartValue: 10,
  }
  customerId = "";
  debtorId = "";
  debtorAccountDetailId = "";
  breadCrumb: BreadCrumbModel;
  uploadedFile: File;
  standardHeightForPscrollContainer = standardHeightForPscrollContainer;
  SystemOwnershipEnumIdType = SystemOwnershipEnumId;
  minDate = new Date();
  passportNo: any;
  debtorTypeEnum = DebtorType;
  passportExpiryDate: any;
  isAnAlphaNumericOnly = new CustomDirectiveConfig({ isAnAlphaNumericOnly: true });

  constructor(private crudService: CrudService, private activatedRoute: ActivatedRoute, private store: Store<AppState>,
    private formBuilder: FormBuilder, private rxjsService: RxjsService, private router: Router, 
    private snackbarService: SnackbarService) {
    this.passportNo = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]);
    this.passportExpiryDate = new FormControl('', Validators.required);
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(selectLeadCreationStepperParamsState$),
      this.store.select(selectLeadHeaderDataState$), this.activatedRoute.queryParams,
      this.store.select(loggedInUserData)]
    ).subscribe((response) => {
      this.serviceAgreementStepsParams = new ServiceAgreementStepsParams(response[0]);
      this.leadHeaderData = response[1];
      if (response[2]) {
        this.customerId = response[2].customerId;
        this.debtorId = response[2].debtorId;
        this.debtorId = response[2].debtorId;
        this.debtorAccountDetailId = response[2].debtorAccountDetailId ? response[2].debtorAccountDetailId : '';
        this.loggedInUserData = response[3];
      }
    });
  }

  ngOnInit() {
    this.combineLatestNgrxStoreData();
    this.rxjsService.getIsInstallationDebtor().subscribe((IsInstallationDebtor: boolean) => {
      this.IsInstallationDebtor = IsInstallationDebtor;
      this.breadCrumb = {
        pageTitle: { key: 'Credit Vetting Result' },
        items: [{
          key: this.leadHeaderData.leadRefNo, routeUrl: 'landingPage'
        }, { key: this.IsInstallationDebtor ? 'Sales & Installation Agreement' : 'Service Agreement' }, { key: 'Credit Vetting Result' }]
      };
    });
    this.getDetails();
    this.createDebterForm();
    this.onFormControlChanges();
  }

  createDebterForm() {
    let debtorBankingDetailsModel = new CreditVettingInfo();
    this.creditVettingInfoForm = this.formBuilder.group({});
    Object.keys(debtorBankingDetailsModel).forEach((key) => {
      this.creditVettingInfoForm.addControl(key,
        new FormControl(debtorBankingDetailsModel[key]));
    });
  }

  onFormControlChanges() {
    this.creditVettingInfoForm.get('isPassportCust').valueChanges.subscribe((isPassportCust: boolean) => {
      if (!isPassportCust) {
        this.creditVettingInfoForm.get('passportNoCustomer').setValidators([Validators.required])
        this.creditVettingInfoForm.get('passportNoCustomer').updateValueAndValidity();
        this.creditVettingInfoForm.get('expiryCustDate').setValidators([Validators.required])
        this.creditVettingInfoForm.get('expiryCustDate').updateValueAndValidity();
        this.creditVettingInfoForm.get('expiryCustMonth').setValidators([Validators.required])
        this.creditVettingInfoForm.get('expiryCustMonth').updateValueAndValidity();
      } else {
        this.creditVettingInfoForm.get('passportNoCustomer').clearValidators();
        this.creditVettingInfoForm.get('passportNoCustomer').updateValueAndValidity();
        this.creditVettingInfoForm.get('expiryCustDate').clearValidators();
        this.creditVettingInfoForm.get('expiryCustDate').updateValueAndValidity();
        this.creditVettingInfoForm.get('expiryCustMonth').clearValidators();
        this.creditVettingInfoForm.get('expiryCustMonth').updateValueAndValidity();
      }
    });
  }

  getMonthFormat() {
    return adjustMonthFormatAsPerPCalendar();
  }

  getDetails() {
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.CREDIT_RESULT, null, false,
      prepareGetRequestHttpParams(null, null,
        {
          customerId: this.customerId,
          debtorAccountDetailId: this.debtorAccountDetailId,
          debtorId: this.debtorId,
          quotationVersionId: this.serviceAgreementStepsParams.quotationVersionId
        }))
      .subscribe((response: IApplicationResponse) => {
        this.details = response?.resources;
        if (this.details && this.details.debtorInformation) {
          if (this.details.debtorInformation.expiryDate) {
            this.details.debtorInformation.expiryDate = new Date(this.details.debtorInformation.expiryDate);
          }
          if (this.details.debtorInformation.dob) {
            this.details.debtorInformation.dob = new Date(this.details.debtorInformation.dob);
          }
          if (this.details?.debtorInformation?.passportNo) {
            this.passportNo.setValue(this.details?.debtorInformation?.passportNo || '');
          }
          if (this.details?.debtorInformation?.passportExpiryDate) {
            this.passportExpiryDate.setValue(this.details?.debtorInformation?.passportExpiryDate ? new Date(this.details?.debtorInformation?.passportExpiryDate) : null);
          }
          let rating = "";
          if (this.details.debtorInformation.isDynamicRating) {
            this.options.rangeLabel = ['0', '5'];
            rating = 'Dynamic';
            this.bottomLabel = rating + ' Score :' + this.details.debtorInformation.creditScore;
            this.needleValue = (parseFloat(this.details.debtorInformation.creditScore) / 5) * 100;
          }
          if (this.details.debtorInformation.isSME) {
            this.options.rangeLabel = ['0', '900'];
            rating = 'SME'
            this.bottomLabel = rating + ' Score :' + this.details.debtorInformation.creditScore;
            this.needleValue = (parseFloat(this.details.debtorInformation.creditScore) / 900) * 100;
          }
          if (!this.details.debtorInformation.isSME && !this.details.debtorInformation.isDynamicRating) {
            this.options.rangeLabel = ['0', '900'];
            this.bottomLabel = rating + ' Score :' + this.details.debtorInformation.creditScore;
            this.needleValue = (parseFloat(this.details.debtorInformation.creditScore) / 900) * 100;
          }
        }
        if (this.details && this.details.debtorBankingInformation && this.details.debtorBankingInformation.accountNo) {
          let len = this.details.debtorBankingInformation.accountNo.length - 4;
          let first = this.details.debtorBankingInformation.accountNo.substring(0, len);
          let last = this.details.debtorBankingInformation.accountNo.substring(len, this.details.debtorBankingInformation.accountNo.length);
          let str = ''
          for (let i = 0; i < first.length; i++) {
            str = str + '*';
          }
          this.details.debtorBankingInformation.accountNo = str + '' + last;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  emitUploadedFiles(uploadedFile) {
    if (!uploadedFile || uploadedFile?.length == 0) {
      return;
    }
    this.uploadedFile = uploadedFile;
  }

  onSubmit() {
    let obj = {
      customerId: this.customerId,
      addressId: this.serviceAgreementStepsParams?.addressId || this.leadHeaderData?.addressId,
      debtorAdditionalInfoId: this.serviceAgreementStepsParams?.debtorAdditionalInfoId,
      isPassport: this.passportNo.value ? true : false,
      passportNo: this.passportNo.value || '',
      passportExpiryDate: this.passportExpiryDate.value ? datePipeConversion(this.passportExpiryDate.value, SERVER_REQUEST_DATE_TRANSFORM) : null,
      modifiedUserId: this.loggedInUserData?.userId,
    }
    this.rxjsService.setFormChangeDetectionProperty(true);
    let formData = new FormData();
    formData.append('data', JSON.stringify(obj));
    if (this.uploadedFile && this.details?.debtorInformation?.systemOwnershipId == this.SystemOwnershipEnumIdType.RENTED) {
      formData.append('file', this.uploadedFile);
    }
    this.crudService.create(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.CREDIT_VETTING_PAYMENT_PROOF, formData)
      .subscribe();
  }

  redirectToDebtorBankingDetails() {
    let urlSuffix = this.IsInstallationDebtor ? 'installation-agreement/debtor-banking-details' :
      'service-agreement/debtor-banking-details';
    if (this.serviceAgreementStepsParams.isOnInvoicePayment) {
      urlSuffix = this.IsInstallationDebtor ? 'installation-agreement/debtor-creation' :
        'service-agreement/debtor-creation';
    }
    if (this.leadHeaderData.fromUrl == 'Leads List') {
      this.router.navigate([`/sales/task-management/leads/${urlSuffix}`]);
    } else {
      this.router.navigate([`/my-tasks/my-sales/my-leads/${urlSuffix}`]);
    }
  }

  getDateFormat() {
    return adjustDateFormatAsPerPCalendar();
  }

  getFileName(filePath: string): string {
    if (!filePath) return 'download';
    const pathOnly = filePath.split('?')[0];
    return pathOnly.split('/').pop() || pathOnly.split('\\').pop() || 'download';
  }

  /** Downloads document. For cross-origin URLs (e.g. Azure blob) the browser may show "Save As"; for same-origin (e.g. LSS) it downloads directly. Pass documentName when available for a better suggested filename. */
  downloadDocument(documentPath: string, documentName?: string, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (documentPath) {
      const fileName = documentName && documentName.trim() ? documentName.trim() : this.getFileName(documentPath);
      fileUrlDownload(
        documentPath,
        fileName,
        false,
        this.crudService,
        this.rxjsService,
        true,
        'download'
      ).catch(error => {
        console.error('Error opening document:', error);
        this.snackbarService.openSnackbar('Unable to open document', ResponseMessageTypes.ERROR);
      });
    }
  }
}
